import { Controller } from "@hotwired/stimulus"

// Mostra/nasconde i campi specifici di Azienda vs Persona fisica.
export default class extends Controller {
  static targets = ["select", "azienda", "personaFisica"]

  connect() { this.toggle() }

  toggle() {
    const azienda = this.selectTarget.value === "azienda"
    this.aziendaTarget.hidden = !azienda
    this.personaFisicaTarget.hidden = azienda
  }
}
